
export default function debounce (cbFunction, waitTime, options = {}) {
    if (!options.hasOwnProperty('trailing')) {
        options.trailing = true
    }
    let timeout
    return function () {
        const context = this
        const args = arguments
        const later = () => {
            timeout = null
            if (options.trailing) {
                cbFunction.apply(context, args)
            }
        }
        const callNow = options.leading && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, waitTime)
        if (callNow) {
            cbFunction.apply(context, args)
        }
    }
}
